export * from './useDeleteGlobalCompanyTab';
export { default as useDeleteGlobalCompanyTab } from './useDeleteGlobalCompanyTab';
